import React from 'react';
import './toast.css';
import { toast } from 'react-toastify';

export function showSuccessToast(message: string, darkMode: boolean) {
  toast.success(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: false,
    theme: darkMode ? 'dark' : 'light',
  });
}
